module.exports = __webpack_public_path__ + "img/img61.30e88373.png";